var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataObservabilityLanding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 7V29H63V7H55ZM61 27H57V9H61V27Z",
    fill: "#39ACE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17.116C44.36 16.544 43.693 16.008 43 15.511V15H42.247C38.35 12.422 33.743 11 29 11H28V36H53V35C53 32.968 52.731 30.958 52.226 29H53V11H45V17.116ZM50.978 34H30V13.022C32.83 13.152 35.587 13.839 38.129 15H35V29H43V18.067C43.7 18.645 44.372 19.258 45 19.924V29H50.156C50.618 30.631 50.901 32.305 50.978 34ZM41 17V27H37V17H41ZM47 13H51V27H47V13Z",
    fill: "#39ACE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.293 31.2968L8.79297 39.7969L10.2072 41.2111L18.7072 32.711L17.293 31.2968Z",
    fill: "#39ACE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 32C13 30.346 11.654 29 10 29C8.346 29 7 30.346 7 32C7 33.654 8.346 35 10 35C11.654 35 13 33.654 13 32ZM9 32C9 31.448 9.448 31 10 31C10.552 31 11 31.448 11 32C11 32.552 10.552 33 10 33C9.448 33 9 32.552 9 32Z",
    fill: "#39ACE7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 37C16.346 37 15 38.346 15 40C15 41.654 16.346 43 18 43C19.654 43 21 41.654 21 40C21 38.346 19.654 37 18 37ZM18 41C17.448 41 17 40.552 17 40C17 39.448 17.448 39 18 39C18.552 39 19 39.448 19 40C19 40.552 18.552 41 18 41Z",
    fill: "#39ACE7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.857 52.443C47.559 48.462 49 43.839 49 39V38H26V15H25C24.012 15 23.007 15.087 22 15.214V1H1V15H13.586L15.539 16.953C6.785 20.712 1 29.378 1 39C1 52.233 11.767 63 25 63C30.803 63 36.331 60.902 40.699 57.113L43.793 60.207C44.401 60.815 45.201 61.12 46 61.12C46.799 61.12 47.599 60.815 48.207 60.207C49.424 58.99 49.424 57.01 48.207 55.793L44.857 52.443ZM3 13V3H20V18.586L14.414 13H3ZM25 61C12.869 61 3 51.131 3 39C3 29.909 8.636 21.753 17.077 18.491L22 23.414V17.22C22.669 17.128 23.338 17.054 24 17.023V40H46.978C46.803 43.945 45.578 47.708 43.42 51.006L41.825 49.411C41.935 48.958 42 48.487 42 48C42 44.691 39.309 42 36 42C32.691 42 30 44.691 30 48C30 51.309 32.691 54 36 54C36.487 54 36.958 53.935 37.411 53.825L39.281 55.695C35.295 59.111 30.272 61 25 61ZM36 52C33.794 52 32 50.206 32 48C32 45.794 33.794 44 36 44C38.206 44 40 45.794 40 48C40 50.206 38.206 52 36 52ZM46.793 58.793C46.355 59.231 45.645 59.231 45.207 58.793L39.373 52.959C39.996 52.534 40.534 51.996 40.959 51.373L46.793 57.207C47.23 57.645 47.23 58.355 46.793 58.793Z",
    fill: "#39ACE7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H5V7H18V5Z",
    fill: "#39ACE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H5V11H18V9Z",
    fill: "#39ACE7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47H35V49H37V47Z",
    fill: "#39ACE7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47H26V49H28V47Z",
    fill: "#39ACE7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24 47H22V49H24V47Z",
    fill: "#39ACE7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 47H18V49H20V47Z",
    fill: "#39ACE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataObservabilityLanding);
export default __webpack_public_path__ + "static/media/Data Observability Landing.aa96d9bcf7c1c0592db24e7542a7069b.svg";
export { ForwardRef as ReactComponent };